<div class="card card-new-members">
    <div class="card-header font-semibold text-xl mb-4 text-center">BPV - Community</div>
    <p-timeline [value]="bpvcommunity" [align]="timelineAlign" styleClass="customized-timeline">
        <ng-template #marker let-event>
            <span class="flex w-8 h-8 items-center justify-center text-white rounded-full z-10 shadow-sm" [style]="{ 'background-color': event.color }">
                <i [class]="event.icon"></i>
            </span>
        </ng-template>
        <ng-template #content let-event>
            <p-card class="mt-4">
                <div class="p-card-header text-xl font-semibold mb-4" [innerHTML]="event.headerline"></div>
                <div class="image-container">
                    <img *ngIf="event.image" [src]="event.image" [alt]="event.name" width="200" class="shadow" />
                </div>
                <p class="mt-4">
                    {{ event.description }}
                </p>
            </p-card>
        </ng-template>
    </p-timeline>
    <div class="font-semibold text-l mb-0 flex justify-center">
        <a href="https://discord.gg/4vuuSMyTuT" target="_blank" rel="noopener noreferrer" class="inline-block shadow-2xl rounded-lg overflow-hidden text-center bg-white/90 dark:bg-gray-800/90 cursor-pointer no-underline px-6 py-3 text-orange-500 transition-all duration-300 hover:scale-105 hover:shadow-orange-500/30" style="font-family: 'CarterOne', sans-serif;">
            <i class="pi pi-discord mr-2"></i>Fahre mit uns<i class="pi pi-arrow-right ml-3"></i>
        </a>
    </div>
</div>
<div class="card card-new-members-liga">
    <div class="card-header font-semibold text-xl mb-4 text-center">BPV - Liga</div>
    <p-timeline [value]="bpvliga" [align]="timelineAlign" styleClass="customized-timeline">
        <ng-template #marker let-event>
            <span class="flex w-8 h-8 items-center justify-center text-white rounded-full z-10 shadow-sm" [style]="{ 'background-color': event.color }">
                <i [class]="event.icon"></i>
            </span>
        </ng-template>
        <ng-template #content let-event>
            <p-card class="mt-4">
                <div class="p-card-header text-xl font-semibold mb-4" [innerHTML]="event.headerline"></div>
                <div class="image-container">
                    <img *ngIf="event.image" [src]="event.image" [alt]="event.name" width="200" class="shadow" />
                </div>
                <p class="mt-4">
                    {{ event.description }}
                </p>
            </p-card>
        </ng-template>
    </p-timeline>
    <div class="font-semibold text-l mb-0 flex justify-center">
        <a href="https://discord.gg/4vuuSMyTuT" target="_blank" rel="noopener noreferrer" class="inline-block shadow-2xl rounded-lg overflow-hidden text-center bg-white/90 dark:bg-gray-800/90 cursor-pointer no-underline px-6 py-3 text-orange-500 transition-all duration-300 hover:scale-105 hover:shadow-orange-500/30" style="font-family: 'CarterOne', sans-serif;">
            <i class="pi pi-discord mr-2"></i>Fahre mit uns<i class="pi pi-arrow-right ml-3"></i>
        </a>
    </div>
</div>
